export default __webpack_public_path__ + "static/media/pricelist-banner@2x.398ca7c3.jpg";